import React, { useEffect, useState } from 'react';
import { useTranslation } from '@clubpay/customer-common-module/src/hook/translations';
import { Button } from '@qlub-dev/qlub-kit';
import QSRDateTimePicker, { IDateTime } from '@/components/QSR/QSRDateTimePicker';
import { IScheduledTime, ScheduledOrderEnum } from '@/components/QSR/QSRScheduledOrder';
import useQsrEventsCenter from '@/hooks/qsrEventsCenter';

import styles from './index.module.scss';

interface IProps {
    value: IScheduledTime | undefined;
    onChange: (val: IScheduledTime) => void;
    onClose?: () => void;
}

const QSRScheduledOrderModal = ({ value, onChange, onClose }: IProps) => {
    const { t } = useTranslation('common');

    const [selectedDate, setSelectedDate] = useState<IDateTime | undefined>(undefined);

    const {
        qsr: { qsrAsapTypeSelected, qsrOrderScheduled },
    } = useQsrEventsCenter();

    const setScheduleClickHandler = () => {
        onChange({
            type: ScheduledOrderEnum.Scheduled,
            value: selectedDate,
        });

        onClose?.();

        if (selectedDate?.date && selectedDate?.timePeriod) {
            qsrOrderScheduled(
                selectedDate?.date,
                `start: ${selectedDate?.timePeriod?.start} end: ${selectedDate?.timePeriod?.end}`,
            );
        }
    };

    useEffect(() => {
        if (value?.type !== ScheduledOrderEnum.ASAP) {
            return;
        }

        qsrAsapTypeSelected();
        setSelectedDate(undefined);
    }, [value?.type]);

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <QSRDateTimePicker value={selectedDate} setValue={setSelectedDate} />
                <Button
                    className={styles.btn}
                    variant="contained"
                    onClick={setScheduleClickHandler}
                    disabled={!selectedDate?.timePeriod}
                >
                    {t('Confirm')}
                </Button>
            </div>
        </div>
    );
};

export default QSRScheduledOrderModal;
